import Skeleton from './Skeleton'

const CardGridSkeleton = ({ count = 6, minWidth = 280 }) => (
  <div
    className="grid gap-4"
    style={{ gridTemplateColumns: `repeat(auto-fill, minmax(${minWidth}px, 1fr))` }}
  >
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} className="overflow-hidden rounded-2xl border border-gray-100 bg-white">
        <Skeleton className="h-40 w-full rounded-none" />
        <div className="space-y-3 p-4">
          <Skeleton className="h-4 w-2/3" />
          <Skeleton className="h-3 w-1/2" />
          <Skeleton className="h-3 w-full" />
          <Skeleton className="h-8 w-full" />
        </div>
      </div>
    ))}
  </div>
)

export default CardGridSkeleton
